// extracted by mini-css-extract-plugin
export default {"bracket":"TournamentBracket_bracket--MxI","mobileBracket":"TournamentBracket_mobileBracket--FQj"};